<template>

  <!-- Courses Admin Start -->
  <div class="section overflow-hidden position-relative" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">
      <div class="container-fluid custom-container">

        <!-- Message Start -->
        <div class="dashboard-head">
          <div class="message-content">
            <h2>Manage Your Profile</h2>
            <h5>Keep Your Information Up to Date</h5>
          </div>
        </div>
        <!-- Message End -->

        <!-- Register & Login Form Start -->
        <div class="register-login-form login-box max-width-700">

          <div class="form-wrapper" v-if='user'>
            <form @submit.prevent="updateUser">
              <div class="single-form">
                <input type="text" class="cap" required placeholder="First Name" v-model='user.first_name'>
              </div>
              <div class="single-form">
                <input type="text" class="cap" required placeholder="Last Name" v-model='user.last_name'>
              </div>
              <div class="single-form">
                <input type="text" placeholder="Phone" :value="(user.country_code || '') + ' ' + (user.phone_number || '')" disabled>
              </div>
              <div class="single-form">
                <input type="text" placeholder="Email" v-model='user.email' disabled>
              </div>
              <div class="single-form">
                <input type="text" class="cap" placeholder="Role" v-model='user.role' disabled>
              </div>
              <div class="single-form">
                <input type="text" class="cap" placeholder="Account Type" v-model='user.org_or_ind' disabled>
              </div>
              <div class="single-form">
                <button class="btn btn-primary btn-hover-dark w-100" type="submit">Update Profile</button>
              </div>
            </form>

            <p v-if='message'>{{message}}</p>


          </div>
        </div>
        <!-- Register & Login Form End -->

        <!-- Message Start -->
        <div class="dashboard-head mt-10">
          <div class="message-content">
            <h2>Update your password</h2>
          </div>
        </div>
        <!-- Message End -->

        <!-- Register & Login Form Start -->
        <div class="register-login-form login-box max-width-700">

          <div class="form-wrapper" v-if='user'>
            <form @submit.prevent="updatePassword">
              
              <div class="single-form password-field">
                <input 
                  :type="showOldPass ? 'text' : 'password'"
                  
                  placeholder="Old Password" 
                  v-model="password.old_pass"
                />
                <button type="button" class="toggle-btn" @click="showOldPass = !showOldPass">
                  {{ showOldPass ? "🔒" : "👁️" }}
                </button>
              </div>

              <div class="single-form password-field">
                <input 
                  :type="showNewPass ? 'text' : 'password'"
                  
                  placeholder="New Password" 
                  v-model="password.new_pass"
                />
                <button type="button" class="toggle-btn" @click="showNewPass = !showNewPass">
                  {{ showNewPass ? "🔒" : "👁️"}}
                </button>
              </div>
              <div class="single-form">
                <button class="btn btn-primary btn-hover-dark w-100" type="submit">Update Password</button>
              </div>
            </form>

            <p v-if='pass_message'>{{pass_message}}</p>


          </div>
        </div>
        <!-- Register & Login Form End -->

      </div>
    </div>
  </div>
  <!-- Page Content Wrapper End -->

</template>

<script>
import { getUserDetails } from '@/services/userService';
import { jwtDecode } from "jwt-decode";
import api from '@/services/api';

export default {
  name: 'AdminProfile',
  data() {
    return {
      user: {},
      message: null,
      pass_message: null,
      password: {},
      showOldPass: false,
      showNewPass: false,
    };
  },

  mounted() {
    const decoded = jwtDecode(localStorage.getItem('access_token'));
    this.token_info = decoded;
    this.getUserDetail();
  },

  methods:{

    async updatePassword() {
      try {
         // Replace with actual logged-in user ID
        const response = await api.put(`/user/update_password/${this.user._id}`, this.password, {
          requiresAuth: true
        });
        this.pass_message = response.data.message;
        this.password.old_pass = "";
        this.password.new_pass = "";
      } catch (error) {
        console.log(error || "Failed to update password");
        this.pass_message = error.response.data.message;
      }
    },

    async updateUser() {
      try {
        this.loading = true;
        const userId = this.user._id; // Ensure _id is included when fetching user data
        const userData = {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          phone_number: this.user.phone_number,
          // email: this.user.email,
          last_modified_by: this.user.email, // Replace with actual modifier (e.g., logged-in user)
        };

        const response = await api.put(`/user/update_user/${userId}`, userData, {
          requiresAuth: true
        });

        this.message = response.data.message;
      } catch (error) {
        console.log(error.message || "Failed to update user details");
      }
    },

    async getUserDetail(){
      this.user = await getUserDetails(this.token_info.email);
      console.log(this.user);
    },
  }
};
</script>

<style scoped>
.cap{
  text-transform: capitalize;
}
.password-field {
  position: relative;
}

.password-field input {
  width: 100%;
  padding-right: 40px;
}

.toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}
</style>